import { Table } from '@circlefin/components'
import { USERS_POLL_INTERVAL } from '@shared/apollo/pollInterval'
import { SimpleTable, TableCard } from '@shared/components/tables'
import { useManageableUsersQuery } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { UsersTableHead } from './UsersTable.Head'
import { UsersTableRow } from './UsersTable.Row/UsersTable.Row'

export const UsersTable: React.FC = () => {
  const { t } = useTranslation('settings')

  const { data, error, loading, refetch } = useManageableUsersQuery({
    fetchPolicy: 'cache-and-network',
    pollInterval: USERS_POLL_INTERVAL,
  })

  return (
    <TableCard>
      <SimpleTable
        empty={t('manageUsers.noUsers')}
        error={error}
        loading={loading}
        numLoadingColumns={3}
        retry={refetch}
        size={data?.manageableUsers.length}
      >
        <UsersTableHead />
        <Table.Body>
          {data?.manageableUsers.map((user) => (
            <UsersTableRow key={user.email} user={user} />
          ))}
        </Table.Body>
      </SimpleTable>
    </TableCard>
  )
}
